<quill-editor
  (onEditorCreated)="editorCreated($event)"
  [formControl]="updateControl"
  [modules]="modules"
  [placeholder]="placeholder"
  [formats]="formats"
  [styles]="{ height: '180px' }"
></quill-editor>
